<template>
  <div>
    <div class="toph mb16" >
      <span>有房提醒</span>
    </div>
    <div>
      <Tabs v-model="shortCut1" class="toph-tabs">
        <TabPane :label="'系统已提醒'+' '+ytxNum" name="ytx"></TabPane>
        <TabPane :label="'待系统提醒'+' '+dtxNum" name="dtx"></TabPane>
      </Tabs>

      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading" :total="total"
        :current="current" @change-page="changePage"
        :defaultTem="isShow"
        :pageSize="5"
      >
      </table-list>


      <close-remind :n="closeKey" :remindFid="closeRemindFid" :remindStatus="remindStatus" @refresh="findData" ></close-remind>
      <create-business-modal :projectList="projectList" :clientTypeList="clientTypeList" :projectFid = "projectFid" :statusList = "statusList" :channelList = "channelList" :customerPhone = "customerPhone"
                             :customerName = "customerName" :isHouseRemind = true :houseTypeFid = "houseTypeFid" :houseRemindFid = "houseRemindFid"
                             :budgetRangeList="budgetRangeList"
                             :commutingModeList="commutingModeList"
                             :intentionAreaList="intentionAreaList"
                             :houseTypeList="houseTypeList"
                             :liveNumberList="liveNumberList"
                             :placeList="placeList"
                             :shortRentDesList="shortRentDesList"
                             :enumList="enumList"
                             :rentTimeList="rentTimeList"  :n = "createKey" @refresh="findData" ></create-business-modal>
      <read-or-handle-modal :n="readOrHandleKey" :zoFid="zoFid" :clientTypeList="clientTypeList" :businessFid = "businessFid" :projectFid="projectFid" :statusList = "statusList"
                            :budgetRangeList="budgetRangeList"
                            :commutingModeList="commutingModeList"
                            :intentionAreaList="intentionAreaList"
                            :houseTypeList="houseTypeList"
                            :liveNumberList="liveNumberList"
                            :placeList="placeList"
                            :shortRentDesList="shortRentDesList"
                            :enumList="enumList"
                            :rentTimeList="rentTimeList"  @refresh="findData" :isRead="isRead"></read-or-handle-modal>
    </div>

  </div>
</template>

<script>
  import TableList from 'components/TableList/index'
  import { getSelectedData, getHouseRemindNum, getDetail, getHistory, handleBusiness, allowHandleBusiness, downloadBusinessList, checkBusinessCount,getIsShowRecord ,getBusinessEnums } from 'api/business';
  import {getList} from "api/roomRemind";
  import { getProjects } from 'api/common'
  import CreateBusinessModal from '../../business/readBusiness/components/CreateBusinessModal';
  import ReadOrHandleModal from '../../business/readBusiness/components/ReadOrHandle';
  import CloseRemind from '../../business/roomRemind/components/CloseRemind.vue'
  export default {
    name: "HouseRemind",
    components: {
      TableList,
      CreateBusinessModal,
      ReadOrHandleModal,
      CloseRemind
    },
    watch:{
      projectFid(){
        this.recordCut = ''
        this.page=1
        this.current=1
        this.getHouseRemindNum()
      },
      shortCut1(value) {
        switch (value) {
          case 'dtx':
            this.clearValue()
            this.renewAgreementState = 0;
            break;
          case 'ytx':
            this.clearValue()
            this.renewAgreementState = 1;
            break;
        }
        this.page=1
        this.current=1
        this.getpageList();
      }
    },
    computed:{

    },
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        shortCut1: 'ytx',
        recordCut:'',
        page: 1,
        limit: 5,
        renewAgreementState:0,
        readKey:0,
        updateKey:0,
        subContractNum:0,
        status:null,
        contractId:'',
        ytxNum: 0,
        dtxNum: 0,
        data:[],
        total:0,
        loading:false,
        current: 1,
        isShow:false,
        leaseTimeList: [],
        createKey:0,
        zoFid:'',
        customerPhone:'',
        customerName:'',
        businessFromChannel:'13',
        houseTypeFid:'',
        houseRemindFid:'',
        readOrHandleKey:0,
        isRead:false,
        closeKey:0,
        closeRemindFid:'',
        businessFid:'',
        remindStatus:0,
        projectList:[],
        clientTypeList:[],
        statusList:[],
        channelList:[],
        sourceList:[],
        budgetRangeList:[],
        commutingModeList:[],
        intentionAreaList:[],
        houseTypeList:[],
        liveNumberList:[],
        placeList:[],
        shortRentDesList:[],
        rentTimeList:[],
        enumList:null,
        columns:[
          {
            type:'index',
            width:60,
          },
          {
            title:' '
          },
          {
            title: '有房提醒状态',
            key: 'remindStatus',
            width:120,
            align: 'center',
            render: (h,params) => {
              return h('div',{
                'class': {
                  'error-color': params.row.remindStatus == 0,
                  'success-color ': params.row.remindStatus == 1,
                  'disable-color':params.row.remindStatus == 2,
                  'disable-color':params.row.remindStatus == 3,
                  'disable-color':params.row.remindStatus == 4,
                },
              },params.row.remindStatusCn)
            }
          },
          {
            title:' '
          },
          {
            title: '客户姓名',
            key: 'customerName',
            width:100,
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '客户电话',
            key: 'customerPhone',
            align: 'center',
            width:120,
          },
          {
            title:' '
          },
          {
            title: '房型名称',
            key: 'houseTypeName',
            align: 'center',
            width:220
          },
          {
            title:' '
          },
          {
            title: '跟进人',
            key: 'zoName',
            align: 'center',
            width:180
          },
          {
            title:' '
          },
          {
            title: '系统触发提醒时间',
            key: 'triggerReminderTime',
            align: 'center',
            width:180
          },
          {
            title:' '
          },
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            width:180
          },
          {
            title:' '
          },
          {
            title: '项目名称',
            key: 'projectName',
            align: 'center',
            width:200

          },
          {
            title:' '
          },
          {
            title: "是否签约",
            key: "contractCode",
            align: "center",
            width:100,
            render: (h, params) => {
              if(params.row.isSignContract == 1){
                return h('a', {
                  on: {
                    click: () => {
                      this.toContractDetail(params.row.contractSn)
                    },
                  }
                }, params.row.isSignContractCn)
              }else {
                return h('span',{},params.row.isSignContractCn)
              }
            }
          },
          {
            title:' '
          },
          {
            title: '操作',
            key: 'action',
            width:150,
            fixed:'right',
            align: 'center',
            render: (h,params)=>{
              return h('div',[
                h('a',{
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'business/createBusiness'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px',
                    display: params.row.remindStatus == 0 || params.row.remindStatus == 1 ? 'inline-block' :'none'
                  },
                  on:{
                    click: () => {
                      this.projectFid = params.row.projectFid
                      this.customerPhone = params.row.customerPhone
                      this.customerName = params.row.customerName
                      this.houseTypeFid = params.row.houseTypeFid
                      this.houseRemindFid = params.row.fid
                      getProjects().then( res=> {
                        this.projectList = res.data
                        getSelectedData().then( res => {
                          this.sourceList = res.data.source
                          this.channelList = res.data.channel
                          this.clientTypeList = res.data.clientType
                          this.statusList = res.data.status
                          const index = this.statusList.findIndex(item => {
                            return item.value == 0
                          })
                          if(index > -1) {
                            this.statusList.splice(index,1)
                          }
                          this.createKey++
                        })
                      })
                    }
                  }
                },'转为商机'),
                h('a',{
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'idelHouseRemind/closeHouseRemind'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px',
                    display: params.row.remindStatus==0 || params.row.remindStatus == 1 ? 'inline-block' :'none'
                  },
                  on:{
                    click: () => {
                      this.closeKey++
                      this.closeRemindFid = params.row.fid
                      this.remindStatus = params.row.remindStatus
                    }
                  }
                },params.row.remindStatus==0?'关闭提醒':'关闭'),h('a',{
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'business/saveBusinessHandle'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px',
                    display: params.row.businessFid!='' && params.row.remindStatus==3 ? 'inline-block' :'none'
                  },
                  on:{
                    click: () => {
                      this.isRead = true
                      this.zoFid = params.row.zoId
                      this.businessFid = params.row.businessFid
                      this.projectFid = params.row.projectFid
                      getSelectedData().then( res => {
                        this.clientTypeList = res.data.clientType
                        this.statusList = res.data.status
                        this.readOrHandleKey++;
                      })
                    }
                  }
                },'查看商机')])
            }
          },
        ],
      }
    },
    methods: {
      changePage(n) {
        this.current = n
        this.page = n
        this.getpageList()
      },
      findData(){
        if (this.data.length === 1) {
          this.current=1
          this.page=1
        }
        this.getHouseRemindNum()
        this.$emit('refreshTotalNum')
      },
      getAllSelect(){
        getBusinessEnums().
        then( res => {
          this.enumList=res.data
          this.budgetRangeList = res.data.budgetRange;
          this.commutingModeList = res.data.commutingMode;
          this.intentionAreaList = res.data.intentionArea;
          this.houseTypeList = res.data.houseType;
          const liveNumberList = res.data.liveNumber;
          for(let i = 1 ; i <= liveNumberList; i++){
            this.liveNumberList.push(i)
          }
          this.placeList = res.data.place;
          this.shortRentDesList = res.data.shortRentDes;
          this.rentTimeList = res.data.rentTime;
        })
      },
      getpageList() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          page:this.page,
          limit: 5,
          remindStatus:this.renewAgreementState,
          isWorkBench:1
        }
        getList(params).then(res => {
          if(!res.data){
            return
          }
          this.data = res.data.rows
          this.total = res.data.total
        }).catch(error=>{})
      },
      getHouseRemindNum() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
        }
        getHouseRemindNum(params).then(res => {
          if(!res || !res.data){
            return
          }
          res.data.forEach((ele)=>{
            if(ele.businessStatus == 0){
              this.dtxNum = ele.number
            }else if (ele.businessStatus == 1){
              this.ytxNum = ele.number
            }
          })

          this.locationTab()
          this.getpageList()
        }).catch(error => {
        })
      },
      clearValue() {
        this.page = 1
        this.limit = 5
      },
      locationTab() {
        if(this.recordCut === 'ytx'){
          this.shortCut1='ytx'
          this.renewAgreementState = 1;
          return
        }else if(this.recordCut === 'dtx'){
          this.shortCut1='dtx'
          this.renewAgreementState = 0;
          return
        }

        if(this.ytxNum){
          this.shortCut1='ytx'
          this.renewAgreementState = 1;
          return
        }else if(this.dtxNum){
          this.shortCut1='dtx'
          this.renewAgreementState = 0;
          return
        }
      },
      initData(){
        this.getHouseRemindNum()
      }
    },
    created() {
      this.initData()
      this.getAllSelect()
    }
  }
</script>

<style scoped>
  .topitem{
    width: 150px;
    text-align: center;
    line-height: 2.2;


  }
  .activeitem{
    color: #CFA868;
  }
  .itemwrapper{
    border-bottom: 1px solid #f9f9f9;

  }
  .toph{
    display: flex;
    background-color: #F4F4F4 ;
    box-shadow: 0 1px 0 0 #F4F4F4;
    justify-content: space-between;
    align-items: center;
    padding:0  20px ;
    box-sizing: border-box;
    line-height: 40px;
  }

</style>
